import React from 'react';
import { X, AlertCircle } from 'lucide-react';
interface ErrorModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
  showUpgradeOption?: boolean;
  onUpgrade?: () => void;
}
export const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  message,
  onClose,
  showUpgradeOption = false,
  onUpgrade
}) => {
  if (!isOpen) return null;
  // Split message for upgrade option (before and after "Would you like")
  const messageParts = message.split('Would you like');
  const mainMessage = messageParts[0].trim();
  const upgradeMessage = messageParts[1] ? `Would you like${messageParts[1]}` : '';
  return <div className="fixed inset-0 z-50 flex items-start justify-center pt-20 px-4" data-id="element-114">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" onClick={!showUpgradeOption ? onClose : undefined} data-id="element-115"></div>

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-2xl max-w-md w-full p-6 z-10 animate-slide-down border-2 border-red-200" data-id="element-116">
        {!showUpgradeOption && <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-117">
            <X className="h-5 w-5" data-id="element-118" />
          </button>}

        <div className="flex items-start" data-id="element-119">
          <div className="flex-shrink-0" data-id="element-120">
            <AlertCircle className="h-6 w-6 text-red-500" data-id="element-121" />
          </div>
          <div className="ml-3 flex-1" data-id="element-122">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-123">
              Unable to Add Item
            </h3>
            {showUpgradeOption ? <div data-id="element-124">
                <p className="text-gray-700 leading-relaxed mb-3" data-id="element-125">
                  {mainMessage}
                </p>
                <p className="text-gray-900 leading-relaxed font-bold" data-id="element-126">
                  {upgradeMessage}
                </p>
              </div> : <p className="text-gray-700 leading-relaxed" data-id="element-127">{message}</p>}
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3" data-id="element-128">
          {showUpgradeOption ? <>
              <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md font-medium hover:bg-gray-300 transition-colors" data-id="element-129">
                No
              </button>
              <button onClick={() => {
            if (onUpgrade) onUpgrade();
            onClose();
          }} className="px-4 py-2 bg-primary-500 text-white rounded-md font-medium hover:bg-primary-600 transition-colors" data-id="element-130">
                Yes
              </button>
            </> : <button onClick={onClose} className="px-4 py-2 bg-red-500 text-white rounded-md font-medium hover:bg-red-600 transition-colors" data-id="element-131">
              Got it
            </button>}
        </div>
      </div>
    </div>;
};